<div class="my-container">
  <ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: true }"></ngx-loading>
</div>

<div class="loginheader" style="display: inline-flex;">
  <div class="col-md-12 col-xs-12 pull-right header-title">
    <div class="pull-left col-sm-12 col-md-8 col-md-offset-3">
      <img
        src="src/app/assets/images/login/goi-logo.png"
        class="pull-left"
        style="margin-right: 10px; padding: 10px;"
        alt="Logo"
        height="150"
      />
      <h1 style="color: #fff; margin-top: 30px;">
        National Programme for prevention and control of NCDs (NP-NCD)
        <!-- <label class="tablet-header" *ngIf="sharedService?.isTablet()">
          (Beta version)
          <span
            matTooltip="The tablet view of the PHC Portal is under beta testing. This is an early look and will continue to improve further."
            class="glyphicon glyphicon-info-sign"
          ></span>
        </label> -->
      </h1>

      <!-- <span>
        <h5 style="color: #fff; line-height: 1.24; margin-left: 15px; font-size: 16px;">
          <span style="display: inline-block;">Comprehensive Primary Health Care</span>
          <div>
            Population based NCDs Prevention, Screening, Control and Management Initiative
          </div>
        </h5>
      </span> -->
    </div>
  </div>
</div>
<div class="container" appNoAutocomplete>
  <div class="row loginControw">
    <div class="col-md-4 col-sm-6 col-xs-10 col-md-offset-4 col-sm-offset-3 col-xs-offset-1">
      <!----------------login-form--start--------------------->
      <div class="well admin-login">
        <form #loginForm="ngForm">
          <div>
            <mat-form-field class="example-full-width" style="width: 100%;">
              <label class="fntr fs16 fw100 pb4 labelCustom"
                >Username
                <span style="color: red;">*</span>
              </label>
              <input
                matInput
                name="username"
                id="username"
                [(ngModel)]="loginObjform.username"
                required
                #username
                maxlength="20"
                #usernameValue="ngModel"
              />
            </mat-form-field>
            <span
              class="error fs12 fntr"
              *ngIf="usernameValue.invalid && (usernameValue.dirty || usernameValue.touched)"
            >
              <span class="error fntr fs12" *ngIf="usernameValue?.errors.required">
                This field is required.
              </span>
            </span>
          </div>

          <div>
            <mat-form-field class="example-full-width" style="width: 100%;">
              <label class="fntr fs16 fw100 pb4 labelCustom"
                >Password
                <span style="color: red;">*</span>
              </label>
              <input
                matInput
                name="password"
                id="password"
                [type]="hidePassword ? 'text' : 'password'"
                [(ngModel)]="loginObjform.password"
                required
                #passwordValue="ngModel"
                minlength="8"
                maxlength="15"
                style="width: 90%;"
              />
              <mat-icon (click)="hidePassword = !hidePassword" class="cursorPointer">
                {{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon
              >
            </mat-form-field>
            <span
              class="error fs12 fntr"
              *ngIf="passwordValue.invalid && (passwordValue.dirty || passwordValue.touched)"
            >
              <span class="error fntr fs12" *ngIf="passwordValue?.errors.required">
                This field is required.
              </span>
            </span>
          </div>

          <div>
            <img class="pull-left" alt="captcha" [src]="base64Image" id="captcha" weight="100" height="70" />
            <mat-icon style="margin: 25px;" class="cursorPointer" (click)="reloadCaptchaImage()">refresh</mat-icon>
          </div>

          <div>
            <mat-form-field class="example-full-width" style="width: 100%;">
              <label class="fntr fs16 fw100 pb4"
                >Enter code shown on the picture
                <!-- <span style="color: red;">*</span> -->
              </label>
              <input
                matInput
                name="captchaInput"
                id="captchaInput"
                [(ngModel)]="loginObjform.captcha"
                #captcha="ngModel"
                maxlength="5"
                required
              />
            </mat-form-field>
            <span class="error fs12 fntr" *ngIf="captcha.invalid && (captcha.dirty || captcha.touched)">
              <span class="error fntr fs12" *ngIf="captcha?.errors.required">
                This field is required.
              </span>
              <span class="error fntr fs12" *ngIf="captcha?.errors.isInvalid">
                Captcha is invalid. Please try again.
              </span>
            </span>
          </div>

          <div class="remember-me">
            <mat-checkbox
              [ngModelOptions]="{ standalone: true }"
              [checked]="loginObjform.rememberMe"
              color="primary"
              [(ngModel)]="loginObjform.rememberMe"
              (change)="setRememberMe($event.checked)"
            >
              Remember Username
            </mat-checkbox>
          </div>

          <div class="row save-btn" style="text-align: center; padding: 10px 0;">
            <button
              #loginBtn
              type="submit"
              class="btn btn-primary"
              style="margin-bottom: 10px; width: 100%;"
              name="submit1"
              (click)="validateForm()"
            >
              Login
            </button>
          </div>

          <a #resetpwd class="btn tac forgotPassLink" (click)="resetPassword()">Reset Password</a>
        </form>
      </div>
    </div>
  </div>
</div>

<footer class="footer col-sm-12 col-md-12">
  <!-- <div>
    <a href="" data-toggle="modal" data-target="#keyContributors">Key Contributors</a>
  </div> -->
  <div class="col-md-4"></div>
  <div class="col-md-2">
    <a href="" data-toggle="modal" data-target="#keyContributors">Key Contributors</a>
  </div>
  <div class="col-md-2">
    <a href="" (click)="navigateToPrivacyPage()">Privacy Policy</a>
  </div>
  <div class="col-md-4"></div>
</footer>

<div class="modal fade" id="keyContributors" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <img src="src/app/assets/images/login/partners.png" alt="key-contributors" height="200" width="100%" />
      </div>
    </div>
  </div>
</div>
